// AnimatedSection.jsx
import React from "react";
import { useInView } from "react-intersection-observer";

export function AnimatedSection({ children, className = "", delay = 0, direction = "up" }) {
  const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.1 });
  const getTransform = () => {
    switch (direction) {
      case "up": return "translateY(40px)";
      case "down": return "translateY(-40px)";
      case "left": return "translateX(-40px)";
      case "right": return "translateX(40px)";
      default: return "translateY(40px)";
    }
  };
  return (
    <div ref={ref} className={className}
      style={{ opacity: inView ? 1 : 0, transform: inView ? "none" : getTransform(), transition: `opacity 0.7s ease ${delay}ms, transform 0.7s ease ${delay}ms` }}>
      {children}
    </div>
  );
}

// SectionLabel.jsx
export function SectionLabel({ text, color = "brand" }) {
  const colors = {
    brand: "text-brand-primary bg-brand-pale",
    gold: "text-accent-gold bg-accent-goldLight",
    teal: "text-accent-teal bg-accent-tealLight",
  };
  return (
    <div className={`inline-flex items-center gap-2 px-4 py-1.5 rounded-full text-xs font-semibold tracking-wider uppercase mb-4 ${colors[color]}`}>
      <span className="w-1.5 h-1.5 rounded-full bg-current" />
      {text}
    </div>
  );
}

// PageLoader.jsx
export function PageLoader() {
  const [visible, setVisible] = React.useState(true);
  React.useEffect(() => { const t = setTimeout(() => setVisible(false), 1500); return () => clearTimeout(t); }, []);
  if (!visible) return null;
  return (
    <div className="fixed inset-0 z-[9999] bg-white flex flex-col items-center justify-center gap-6 transition-opacity duration-500">
      <img src="/logo.png" alt="Sava Fresh" className="h-16 w-auto object-contain" />
      <div className="loader-ring" />
    </div>
  );
}

// ProtectedRoute.jsx
import { Navigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="loader-ring" />
    </div>
  );
  if (!user) return <Navigate to="/admin" replace />;
  return children;
}

export { WysiwygEditor } from "./WysiwygEditor";
export { Seo } from "./Seo";
